"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = require("@airstudio/state");
const aws_amplify_1 = require("aws-amplify");
class Amplify extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'amplify';
        state_1.Bus.onConfigReady(async ({ amplify }) => {
            aws_amplify_1.default.configure(amplify);
            try {
                const user = await aws_amplify_1.default.Auth.currentAuthenticatedUser();
                const jwt = user.signInUserSession.idToken.jwtToken;
                await state_1.Operations.Session.login(this.dispatch)(jwt);
            }
            catch (_a) {
                await state_1.Operations.Session.logout(this.dispatch)();
            }
        });
        aws_amplify_1.Hub.listen('auth', async ({ payload }) => {
            if (payload.event === 'signIn') {
                const jwt = payload.data.signInUserSession.idToken.jwtToken;
                await state_1.Operations.Session.login(this.dispatch)(jwt);
            }
        });
        aws_amplify_1.default.Analytics.autoTrack('pageView', {
            enable: true,
            eventName: 'pageView',
            type: 'SPA',
        });
        state_1.Bus.onAnalytics(({ eventName, args, value }) => {
            const metrics = value ? { value } : {};
            aws_amplify_1.default.Analytics.record({
                metrics,
                name: eventName,
                attributes: args,
            });
        });
    }
}
exports.Amplify = Amplify;
//# sourceMappingURL=index.js.map